import { render } from "./ProductsPage.vue?vue&type=template&id=61c68112"
import script from "./ProductsPage.vue?vue&type=script&lang=js"
export * from "./ProductsPage.vue?vue&type=script&lang=js"

import "./ProductsPage.vue?vue&type=style&index=0&id=61c68112&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__